import {
  isAfterThisWeek,
  isAfterToday,
  isThisWeek,
  isToday,
  isYesterday,
  subtractTimeZone,
} from 'helpers';

import { tasksStatusesIds } from 'settings/constants/transactionTasks';

export const TASK_TABS = {
  Overdue: 'Overdue',
  Yesterday: 'Yesterday',
  Today: 'Today',
  ThisWeek: 'This Week',
  Upcoming: 'Upcoming',
  Done: 'Done',
  NA: 'N/A',
  Archive: 'Archive',
};

export const emptyTasksText = 'No Tasks.';
const filteredStatuses = [tasksStatusesIds.overdue, tasksStatusesIds.done, tasksStatusesIds.na];

function overDueTasks(taskList) {
  return taskList.filter((item) => item?.Status === tasksStatusesIds.overdue);
}

function todayTasks(taskList) {
  return taskList.filter((item) => {
    let dueDate = item.DueDate ? subtractTimeZone(item.DueDate, 'M/DD/YYYY') : 'N/A';

    return isToday(dueDate) && !filteredStatuses.includes(item?.Status);
  });
}

function thisWeekTasks(taskList) {
  return taskList.filter((item) => {
    let dueDate = item.DueDate ? subtractTimeZone(item.DueDate, 'M/DD/YYYY') : 'N/A';

    return isThisWeek(dueDate) && isAfterToday(dueDate) && !filteredStatuses.includes(item?.Status);
  });
}

function upcomingTasks(taskList) {
  return taskList.filter((item) => {
    let dueDate = item.DueDate ? subtractTimeZone(item.DueDate, 'M/DD/YYYY') : 'N/A';

    return isAfterThisWeek(dueDate) && !filteredStatuses.includes(item?.Status);
  });
}

function doneTasks(taskList) {
  return taskList.filter((item) => item.Status === tasksStatusesIds.done);
}

function naTasks(taskList) {
  return taskList.filter((item) => item.Status === tasksStatusesIds.na);
}

export const formatTasks = (tasks) => {
  const formattedTasks = tasks?.map((task) => {
    if (task.formProcessDetails) {
      const formProcessDetails = task.formProcessDetails;
      if (formProcessDetails.taskName) {
        task.Title = task.formProcessDetails.taskName;
      }
      if (formProcessDetails.participants?.length) {
        task.AssigneeList = formProcessDetails.participants;
      }
    }
    return task;
  });

  return formattedTasks;
};

export const prepareTasksData = (dataProps) => {
  const { tasks } = dataProps;

  const taskList = formatTasks(tasks);
  return {
    overdue: overDueTasks(taskList),

    today: todayTasks(taskList),
    thisWeek: thisWeekTasks(taskList),
    upcoming: upcomingTasks(taskList),
    archivedTasks: {
      done: doneTasks(taskList),
      na: naTasks(taskList),
    },
  };
};

export const getArchivedTasksDataSource = (archivedValue, archivedTasks) => {
  if (archivedValue === TASK_TABS.Done) return archivedTasks.done;

  if (archivedValue === TASK_TABS.NA) return archivedTasks.na;

  return [];
};

export const getArchivedTasksOptions = (archivedTasks) => {
  const { done, na } = archivedTasks;

  return [
    { label: 'Done', count: done.length },
    { label: 'N/A', count: na.length },
  ];
};
